import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-items-list',
  templateUrl: './items-list.component.html',
  styleUrls: ['./items-list.component.css']
})
export class ItemsListComponent implements OnInit {

  @Input() skills: any;
  @Output() skill: EventEmitter<any> = new EventEmitter<any>();
  constructor(private _router: Router) { }

  title: string;

  ngOnInit() {
    if (this._router.url == "/sme") {
      this.title = "Skills"
    }
    else if (this._router.url == "/certifications") {
      this.title = "Certifications";
    }
  }
  updateSkill(data) {
    this.skills.forEach(i => i.selected = false);
    data.selected = true;
    this.skill.emit(data);
  }

}
